import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';

export const createTouristESim = createAsyncThunk('touristESimBlock/createTouristESim', async (data, thunkAPI) => {
  console.log('data', data.paymentInfo.authNumber);
  thunkAPI.dispatch(showAppLoader());
  let state = thunkAPI.getState().touristESimBlock;
  try {
    const params = {
      // quotaPerCustomer: state.touristESimBlock.totalPrice,
      email: state.email,
      paymentTransaction: data.paymentInfo.token,
      offerId: state.offerId,
      passportId: data.paymentInfo.id, //state.touristESimBlock.lastName,
    };
    const result = await ProviderManager.getProviderData('createTouristESim', params);
    return result;
  } catch (error) {
    console.info(error);
    return false;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

const initialState = {
  page: 'paymentPage',
  packageName: '',
  email: '',
  offerId: '',
  paymentInfo: {iframeUrl: '', numberOfPayments: ''},
  totalPrice: 0,
};
const touristESimBlockSlice = createSlice({
  name: 'touristESimBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initTouristESim: (state, action) => {
      state.packageName = action.payload.touristESimBlock.packageName;
      state.offerId = action.payload.touristESimBlock.offerId;
    },
    goToPage: (state, action) => {
      state.page = action.payload;
    },
    resetCgIframeUrl: (state, action) => {
      state.paymentInfo.iframeUrl = null;
    },
  },
  extraReducers: {
    // [CreateTouristESim.pending]: (state, action) => {},
    // [CreateTouristESim.fulfilled]: (state, action) => {
    //   return state;
    // },
  },
});
export const {resetBlock, initTouristESim, resetCgIframeUrl, goToPage} = touristESimBlockSlice.actions;

export default touristESimBlockSlice.reducer;
